import { useEffect, useState } from "react";
import { ThemeProvider } from "styled-components";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChatContainer from "./components/ChatContainer";
import ThemeSelector from "./components/ThemeSelector";
import { GlobalStyle } from "./styles/GlobalStyle";
import {
  darkTheme,
  corporateBlueTheme,
  blueTheme,
  relaxedNightTheme,
  forestTheme,
  smoothBlack,
  orangeTheme,
} from "./styles/theme";
import { useClientConfig } from "./hooks/useClientConfig";

const themes = {
  orangeTheme,
  dark: darkTheme,
  corporate: corporateBlueTheme,
  night: relaxedNightTheme,
  forest: forestTheme,
  blue: blueTheme,
  smoothBlack,
};

export default function App() {
  const config = useClientConfig();
  const [themeName, setThemeName] = useState("orangeTheme");

  useEffect(() => {
    const preferred = config.defaultTheme;
    if (preferred && themes[preferred]) setThemeName(preferred);
  }, [config.defaultTheme]);

  const currentTheme = themes[themeName] || orangeTheme;

  return (
    <ThemeProvider theme={currentTheme}>
      <GlobalStyle />
      <ChatContainer />
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        bodyClassName="custom-toast-body"
      />
      {config.useThemeSelector && (
        <ThemeSelector
          themeName={themeName}
          setThemeName={setThemeName}
          showSelector
        />
      )}
    </ThemeProvider>
  );
};
